import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Transition as _Transition, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "wrapper"
};
const _hoisted_2 = { class: "cart" };
const _hoisted_3 = { class: "centered constraints small mt-6" };
const _hoisted_4 = { class: "simplePage" };
import { ref, onMounted, useTemplateRef } from 'vue';
import { useRoute } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useVouchers } from '@/composables/useVouchers';
import { useContent } from '@/composables/useContent';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import StripeCheckout from './elements/StripeCheckout.vue';
import DrawerPanel from './elements/DrawerPanel.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'VoucherCheckoutPage',
    setup(__props) {
        const route = useRoute();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getAvailableVoucher, getCustomerVouchers, getCustomerFavouriteVouchers, removeUnavailableDiscountProviders, removeCustomerFavouriteDiscount, addCustomerFavouriteDiscount, createPayment } = useVouchers();
        const { getCmsArticleByKey } = useContent();
        const doubleDrawer = useTemplateRef('doubleDrawer');
        const useCredit = ref(false);
        const total = ref(null);
        const subTotal = ref(null);
        const processingFee = ref(null);
        const amountToPayToday = ref(null);
        const faceValue = ref(null);
        const errorText = ref(null);
        const paymentLoading = ref(false);
        const paymentResponse = ref(null);
        const paymentPending = ref(false);
        const voucherResponse = ref(null);
        const closable = ref(true);
        const showAll = ref(false);
        const guide = ref(null);
        async function onLoad() {
            if (route.query.total !== undefined) {
                total.value = parseFloat(route.query.total);
            }
            if (route.query.subTotal !== undefined) {
                subTotal.value = parseFloat(route.query.subTotal);
            }
            if (route.query.processingFee !== undefined) {
                processingFee.value = parseFloat(route.query.processingFee);
            }
            if (route.query.useSavedToSpend !== undefined) {
                useCredit.value = route.query.useSavedToSpend === 'true' || route.query.useSavedToSpend === true;
            }
            if (route.query.amountToPayToday !== undefined) {
                amountToPayToday.value = parseFloat(route.query.amountToPayToday);
            }
            if (route.query.faceValue !== undefined) {
                faceValue.value = parseFloat(route.query.faceValue);
            }
            getCustomer();
            getCustomerVouchers();
            getAvailableVoucher(route.params.id, () => {
                removeUnavailableDiscountProviders(state.availableVoucher);
                getCustomerFavouriteVouchers((f) => {
                    if (state.availableVoucher && f && f.length > 0) {
                        state.availableVoucher.favourite = f.some((fav) => fav.id === state.availableVoucher.id);
                    }
                });
                getCmsArticleByKey(("VG_" + state.availableVoucher.merchant.name.replaceAll("&", '').toUpperCase()).substring(0, 10), (article) => {
                    if (article) {
                        guide.value = article;
                    }
                });
                if (total.value && !paymentLoading.value && !paymentResponse.value) {
                    stripePay();
                }
            });
        }
        function toggleDrawer() {
            doubleDrawer.value?.toggleDrawer();
        }
        function stripePay() {
            paymentLoading.value = true;
            closable.value = false;
            var meta = {
                type: "voucher",
                voucherId: state.availableVoucher.id,
                slug: state.availableVoucher.merchant.slug,
                amount: faceValue.value
            };
            var paymentRequest = {
                meta: JSON.stringify(meta),
                useVoucherCredit: useCredit.value,
                type: 1,
                returnUrl: window.location.href.split("#")[0] + "#/PaymentComplete",
                amountInPence: parseInt(String(Math.round(parseFloat(String(faceValue.value)) * 100))),
                productDescription: "MG " + state.availableVoucher.merchant.name + " Voucher",
                paymentReference: state.availableVoucher.merchant.name.length > 22 ? state.availableVoucher.merchant.name.substring(0, 22) : state.availableVoucher.merchant.name
            };
            createPayment(paymentRequest, (response) => {
                paymentResponse.value = response.data;
                paymentPending.value = true;
            });
        }
        function toggleFavourite() {
            if (state.availableVoucher.favourite) {
                removeCustomerFavouriteDiscount(state.availableVoucher, () => {
                    state.availableVoucher.favourite = false;
                });
            }
            else {
                addCustomerFavouriteDiscount(state.availableVoucher, () => {
                    state.availableVoucher.favourite = true;
                });
            }
        }
        function showDoubleBubble() {
            doubleDrawer.value?.openDrawer();
        }
        function calcCashback(amount) {
            if (amount && state.availableVoucher && state.availableVoucher.effectiveDiscountPercentage) {
                var cashback = amount * (state.availableVoucher.effectiveDiscountPercentage / 100);
                return state.formatter.format(cashback);
            }
            return "£0 cashback";
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_icon = _resolveComponent("v-icon");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "Complete your purchase",
                    border: "0"
                }),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).availableVoucher
                }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).availableVoucher)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    (paymentLoading.value && !paymentResponse.value)
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 0,
                                            flat: true,
                                            class: "mt-7 mg-button",
                                            disabled: true
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_progress_circular, { indeterminate: "" })
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true),
                                    (paymentResponse.value)
                                        ? (_openBlock(), _createBlock(StripeCheckout, {
                                            key: 1,
                                            class: "mt-2",
                                            secret: paymentResponse.value.paymentLink,
                                            stripeKey: _unref(route).meta.stripeKey
                                        }, null, 8, ["secret", "stripeKey"]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("p", _hoisted_3, [
                                        _createVNode(_component_v_icon, {
                                            style: { "margin-top": "-4px" },
                                            icon: "mdi-lock"
                                        }),
                                        _cache[0] || (_cache[0] = _createTextVNode(" Payments are protected by bank grade encryption."))
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                (_unref(state).availableVoucher && _unref(state).availableVoucher.stackWith && _unref(state).availableVoucher.stackWith.length > 0)
                    ? (_openBlock(), _createBlock(DrawerPanel, {
                        key: 0,
                        ref_key: "doubleDrawer",
                        ref: doubleDrawer,
                        openHeight: "70%",
                        bottom: "-10px",
                        closedHeight: "0",
                        title: "What is Double Bubble?",
                        backgroundColor: "white",
                        openBackgroundColor: "white"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                                _cache[1] || (_cache[1] = _createElementVNode("h1", null, "Double Bubble?", -1)),
                                _createVNode(_component_v_icon, {
                                    icon: "mdi-circle-double",
                                    class: "heroImg"
                                }),
                                _cache[2] || (_cache[2] = _createElementVNode("p", null, "Double Bubble allows you to combine a Money Guided cashback voucher with another discount at point of sale to double down on your savings!", -1)),
                                _createElementVNode("p", null, "For example, at " + _toDisplayString(_unref(state).availableVoucher.merchant.name) + ", you may be able to use your " + _toDisplayString(_unref(state).availableVoucher.stackWith[0]) + " at point of sale and get a discount on your final bill, then use a Money Guided cashback voucher to pay, saving you a lot more!", 1),
                                _createElementVNode("p", null, "Check your " + _toDisplayString(_unref(state).availableVoucher.stackWith[0]) + " to see what you can combine with Money Guided vouchers at " + _toDisplayString(_unref(state).availableVoucher.merchant.name) + ".", 1),
                                _cache[3] || (_cache[3] = _createElementVNode("p", null, [
                                    _createElementVNode("small", null, "While we try our best to highlight potential opportunities for Double Bubble, your mileage may vary.")
                                ], -1))
                            ])
                        ]),
                        _: 1
                    }, 512))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
